import styled, { css } from 'styled-components';

export const Card = styled.section(
  ({ theme }) => css`
    width: 100%;
    box-sizing: border-box;
    background-color: ${theme.co.neutral99};
    border: ${theme.sz.s2} solid ${theme.co.neutral99};
    border-radius: ${theme.bo.mediumLarge};
    padding: ${theme.sz.s5} ${theme.sz.s5} ${theme.sz.s4};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s3};
    box-shadow: 0 ${theme.sz.s2} ${theme.sz.s5} rgba(41, 55, 73, 0.12);

    @media (max-width: ${theme.sz.md}) {
      padding: ${theme.sz.s4};
      gap: ${theme.sz.s2};
    }
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.s};
    color: ${theme.co.secondary20};
    margin: 0;
    text-align: center;
  `,
);

export const Subtitle = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    color: ${theme.co.secondary50};
    margin: 0;
    text-align: center;
  `,
);
